import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";

import { Lightbulb } from "lucide-react";

export const Route = createFileRoute("/_layout-private/chat/_layout/")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="flex flex-col justify-center  items-center w-full min-h-[calc(100vh-200px)] gap-4 ">
			<Lightbulb className="w-[100px] h-[100px] text-yellow-400" />

			<p className="text-muted-foreground">
				ເລີ່ມຕົ້ນການສົນທະນາໄດ້ໂດຍການກົດລາຍການສົນທະນາທີ່ຢູ່ທາງເບຶ້ອງຊ້າຍ
			</p>
		</div>
	);
}
